import {Component, Input, OnInit} from "@angular/core";
import {JP} from "../../helpers/jp";
import * as _ from "underscore";
import {DEF_INPUT_SIZE} from "../../enums/enums";
import {ModalService} from "../../services/modal.service";
import {WatchService} from "../../services/watch.service";
import {localeUtils} from "../../helpers/locale-utils";

@Component({
  selector: 'nv-locale',
  templateUrl: './nv-locale.component.html',
  styles: []
})
export class NvLocaleComponent implements OnInit {
  private _label: string;

  @Input() hideLabel: boolean = false;

  @Input()
  set label(v: string) {
    this._label = v;
  }

  get label() {
    return this._label || this.key;
  }

  private _inputSize: number = DEF_INPUT_SIZE;

  @Input()
  set inputSize(v: number) {
    this._inputSize = v;
  }

  get inputSize() {
    return this._inputSize;
  }

  private _document: any;

  @Input()
  set document(v: any) {
    this._document = v;
    this.createLocalesArrayIfHasNot();
    this.updateCurrentLocaleItem();
  }

  get document() {
    return this._document;
  }

  private _prop: string = "/locales";

  get prop() {
    return `${this._prop}/${localeUtils.getLocale()}`;
  }


  private _key: string;

  @Input()
  set key(v: string) {
    this._key = v;
    this.updateCurrentLocaleItem();
  }

  get key() {
    return this._key;
  }

  item: ILocaleItem = null;


  constructor(private modalService:ModalService,
              private watchService:WatchService) {
  }


  ngOnInit() {
  }


  onInputChange() {
    this.watchService.notify();
  }


  onShowClick() {
    this.modalService.showLocaleEditor(this.item);
  }


  private createLocalesArrayIfHasNot() {
    if (!this.document) {
      return;
    }
    console.log(`need ${this.prop}`);
    if (!JP.has(this.document, this.prop) || !_.isArray(JP.get(this.document, this.prop))) {
      console.log(`create ${this.prop}`);
      JP.set(this.document, this.prop, []);
    }
  }


  private updateCurrentLocaleItem() {
    if (!this.document || !this.key) {
      return;
    }
    this.item = this.getOrCreateLocaleItem();
  }


  private getOrCreateLocaleItem(): ILocaleItem {
    const locales = this.getAllLocales();
    for (let i = 0; i < locales.length; ++i) {
      if (locales[i].key === this.key) {
        return locales[i];
      }
    }

    const empty: ILocaleItem = {
      key: this.key,
      value: [""]
    };

    locales.push(empty);
    return empty;
  }


  private getAllLocales(): ILocaleItem[] {
    return JP.get(this.document, this.prop);
  }
}


export interface ILocaleItem {
  key: string;
  value: string[];
}



// WEBPACK FOOTER //
// /opt/app/develop/src/app/components/nv-locale/nv-locale.component.ts